<template>
    <div>
        <h5 class="mt-1 mb-4">{{ $t('identity_information').toUpper() }}</h5>
        <div class="border rounded p-4 mb-3">
            <b-row>
                <b-col cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>{{ $t('name') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'name') }}
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>{{ $t('surname') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'surname') }}
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>{{ $t('middle_name') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'middle_name') }}
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>{{ $t('passport_number') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'passport_number') }}
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>{{ $t('passport_country') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'passport_country_name') }}
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>{{ $t('gender') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'gender') }}
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>{{ $t('date_of_birth') }}</label>
                        <div>
                            {{ studentProgram.birthdate ? this.toLocaleDate(studentProgram.birthdate) : '-' }}
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>{{ $t('birthplace') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'birthplace') }}
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>{{ $t('nationality') }}</label>
                        <div>
                            {{ studentProgram.nationality_name }}
                        </div>
                    </div>
                </b-col>

                <b-col cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>{{ $t('race') }}</label>
                        <div>
                            {{ this.getObjectValue(studentProgram, 'race_text') }}
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>{{ $t('Visa Type') }}</label>
                        <div>{{ getObjectValue(studentProgram, 'visa_type_name') }}</div>
                    </div>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>{{ $t('application_number') }}</label>
                        <div>
                            {{studentProgram.application_number ? studentProgram.application_number : '-'}}
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>{{ $t('ssn') }}</label>
                        <div>
                            {{studentProgram.ssn ? studentProgram.ssn : '-'}}
                        </div>
                    </div>
                </b-col>
                <b-col v-if="!isYouthProgram && !isTeflProgram && !isCeProgram" cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>{{ $t('SEVIS ID') }}</label>
                        <div>{{ getObjectValue(studentProgram, 'sevis_id') }}</div>
                    </div>
                </b-col>
                <b-col cols="12" md="4" v-if="studentProgram && studentProgram.student_type=='mentora' && studentProgram.old_student_number">
                    <div class="label-as-input-div">
                        <label>HFCenta Student ID</label>
                        <div>{{ getObjectValue(studentProgram, 'old_student_number') }}</div>
                    </div>
                </b-col>
            </b-row>
        </div>

        <b-button variant="primary"
                  @click="updateFormShow"
                  v-if="checkPermission('studentprogram_identityupdate') && editMode">
            {{ $t('edit') }}
        </b-button>

        <CommonModal ref="formModal"
                     size="xl"
                     @bHideModalHeaderClose="clearFormData()"
                     :onHideOnlyX="true"
                     v-if="checkPermission('studentprogram_identityupdate') && editMode">
            <template v-slot:CommonModalTitle>
                {{ $t('edit').toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <update-form :studentProgram="studentProgram"
                             @updateFormSuccess="updateFormSuccess()"
                             v-if="formProcess=='update'"
                />
            </template>
        </CommonModal>
    </div>
</template>
<script>
    // Component
    import CommonModal from '@/components/elements/CommonModal';

    // Pages
    import UpdateForm from './UpdateForm';

    // Services
    import ConstantService from "@/services/ConstantService";

    export default {
        components: {
            CommonModal,
            UpdateForm
        },
        props: {
            studentProgram: {
                type: Object,
                default: null
            },
            editMode: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                formProcess: null,
            }
        },
        computed: {
            isYouthProgram() {
                return this.studentProgram?.program_code === '0702004'
            },
            isTeflProgram() {
              return this.studentProgram?.program_code === '0702006'
            },
            isCeProgram() {
              return this.studentProgram?.program_code === '0702005'
            }
        },
        methods: {
            // Clear
            clearFormData() {
                this.formProcess = null
            },

            // Update
            updateFormShow() {
                this.formProcess = 'update'
                this.$refs.formModal.$refs.commonModal.show()
            },
            updateFormSuccess() {
                this.clearFormData();
                this.$refs.formModal.$refs.commonModal.hide()
                this.$emit('updatedData', true);
            }
        }
    }
</script>

